import React from "react";
import * as R from "ramda";
import { actions, getters } from "../../model";
import { connect } from "react-redux";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import ListSubheader from "@material-ui/core/ListSubheader";

import FileIcon from "ui-kit/FileIcon";
import RowFile from "./RowFile";

import { makeStyles } from "@material-ui/core/styles";
import "./styles.scss";

const useStyles = makeStyles({
  root: {},
  label: {},
  avatarRoot: {
    maxWidth: 30
  }
});

const decorate = R.compose(
  connect(
    state => ({
      files: getters.fileUploadFiles(state),
      progress: getters.fileUploadProgress(state),
      viaPortal: getters.viaPortal(state)
    }),
    {
      cancelUpload: actions.cancelFileUpload
    }
  )
);

const FileTable = ({ files, progress, cancelUpload, viaPortal }) => {
  const classes = useStyles();
  return (
    !R.isEmpty(files) && (
      <>
        <List
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Files
            </ListSubheader>
          }
        >
          {Object.values(files).map(file => {
            return (
              <ListItem>
                <ListItemAvatar className={{ root: classes.avatarRoot }}>
                  <FileIcon size={20} mimetype={file.mimetype} />
                </ListItemAvatar>
                <ListItemText
                  primary={<RowFile file={file} viaPortal={viaPortal} />}
                />
                <ListItemSecondaryAction>
                  {progress[file.uploadId]?.totalPercent >= 100 ? (
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => cancelUpload(file.uploadId)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  ) : null}
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
        <Divider />
      </>
    )
  );
};

export default decorate(FileTable);
